import { render, staticRenderFns } from "./StockAdd.vue?vue&type=template&id=7c7bf9c9&"
import script from "./StockAdd.vue?vue&type=script&lang=js&"
export * from "./StockAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockAdd.vue"
export default component.exports